import React, { useState } from 'react';
import api from '../utils/Api';
import { api_url_v1 } from '../utils/Config';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Oval } from 'react-loader-spinner';

const DisburseMessageModal = ({ onClose, users }) => {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const userIds = users.map((user) => user.id)
    const { token } = useSelector((state) => state.auth)

    console.log(userIds)

    const handleSubmit = async () => {
        const data = {
            subject,
            message,
            users_ids: userIds
        }
        setLoading(true)
        try {
            const response = await api.post(`${api_url_v1}/users-send-communique`, data, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": 'application/json'
                }
            })
            onClose()
            toast.success('Communique disbursed successfully')
            return response.data
            
        } catch (error) {
            console.log(error);
            toast.error('Failed to send communique')
        } finally {
            setLoading(false)
    
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
                <h2 className="text-xl font-bold mb-4">Communique</h2>
                <form >
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Subject</label>
                        <input
                            type="text"
                            name="subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Message</label>
                        <textarea
                            name="message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                            rows={6}
                        />
                    </div>

                    <div className="flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            type="button"
                            className="w-fit sm:w-fit font-lufga text-white bg-[#1330C5] hover:opacity-90 focus:outline-none rounded-md shadow-md text-base px-4 py-2 sm:px-10 sm:py-2 text-center transition-colors"
                        >
                            {loading ? (
                                <div className="">
                                    <Oval
                                        visible={true}
                                        height="20"
                                        width="20"
                                        color="#ffff"
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />
                                </div>
                            ) : 'Send Message'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DisburseMessageModal;